<template>
  <!-- 对话框 -->
  <el-dialog :visible.sync="show" :before-close="closeDialog" style="width:75%; margin: 0 auto;">
    <div style="height: 70vh;overflow-y: auto;">
      <el-row style="padding: 10px 0; border-bottom: 1px dashed #ccc;">
        <el-col :span="24">
          <span style="margin-right: 5px;display:inline-block;width:100px;text-align: right;">真实姓名:</span>
          <span>{{demermine_data.real_name}}</span>
        </el-col>
      </el-row>

      <el-row style="padding: 10px 0; border-bottom: 1px dashed #ccc;">
        <el-col :span="24">
          <span style="margin-right: 5px;display:inline-block;width:100px;text-align: right;">身份证号:</span>
          <span>{{demermine_data.id_card}}</span>
        </el-col>
      </el-row>

      <el-row style="padding: 10px 0; border-bottom: 1px dashed #ccc;">
        <el-col :span="24">
          <span style="margin-right: 5px;display:inline-block;width:100px;text-align: right;">驾驶证类型:</span>
          <span>{{demermine_data.driver_card_mode}}</span>
        </el-col>
      </el-row>

      <el-row style="padding: 10px 0; border-bottom: 1px dashed #ccc;">
        <el-col :span="24">
          <span style="margin-right: 5px;display:inline-block;width:100px;text-align: right;">审核状态:</span>
          <span>{{demermine_data.verify_status == '1'?'通过':demermine_data.verify_status == '2'?'拒绝':'待审'}}</span>
        </el-col>
      </el-row>

      <el-row style="padding: 10px 0; border-bottom: 1px dashed #ccc;">
        <el-col :span="24">
          <span style="margin-right: 5px;display:inline-block;width:100px;text-align: right;">审核备注:</span>
          <span>{{demermine_data.verify_remarks}}</span>
        </el-col>
      </el-row>



      <el-row style="padding: 10px 0; border-bottom: 1px dashed #ccc;">
        <el-col :span="24">
          <span style="margin-right: 5px;display:inline-block;width:100px;text-align: right;">身份证人像面:</span>
          <img :src="demermine_data.id_card_portrait.url" alt="">
        </el-col>
      </el-row>

      <el-row style="padding: 10px 0; border-bottom: 1px dashed #ccc;">
        <el-col :span="24">
          <span style="margin-right: 5px;display:inline-block;width:100px;text-align: right;">身份证国徽面:</span>
          <img :src="demermine_data.id_card_china.url" alt="">
        </el-col>
      </el-row>

      <el-row style="padding: 10px 0; border-bottom: 1px dashed #ccc;">
        <el-col :span="24">
          <span style="margin-right: 5px;display:inline-block;width:100px;text-align: right;">驾驶证:</span>
          <img :src="demermine_data.driver_card.url" alt="">
        </el-col>
      </el-row>

      <el-row style="padding: 10px 0; border-bottom: 1px dashed #ccc;">
        <el-col :span="24">
          <span style="margin-right: 5px;display:inline-block;width:100px;text-align: right;">手持身份证:</span>
          <img :src="demermine_data.id_card_hold.url" alt="">
        </el-col>
      </el-row>




      <el-row style="padding: 10px 0; border-bottom: 1px dashed #ccc;">
        <el-col :span="24">
          <span style="margin-right: 5px;display:inline-block;width:100px;text-align: right;">备注:</span>
          <span>{{demermine_data.remarks}}</span>
        </el-col>
      </el-row>


    </div>
  </el-dialog>
</template>

<script>
  var _this;
  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        //初始化请求
        _this.$post(
            '/driver/getDriverVerifyDetails', {
              driver_code: _this.data
            }
          )
          .then(res => {

           

            _this.demermine_data = res.data;

          }).catch((err) => {

          })

      },

    },
    data() {
      return {

        show: false,

        demermine_data: '',

      };
    },
    created() {
      _this = this;

    },
    methods: {


      // 关闭方法
      closeDialog() {

        _this.show = false;


      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }
</style>